import localeMetadata from '../i18n.locales.json';

export type SupportedLocale = (typeof localeMetadata.supportedLocales)[number];

export const supportedLocales = localeMetadata.supportedLocales;
export const defaultLocale = localeMetadata.defaultLocale;
export const fallbackLocale = localeMetadata.fallbackLocale;
export const languageOptions = localeMetadata.languageOptions;

const supportedLocaleSet = new Set<string>(supportedLocales);
const localeAliases = localeMetadata.localeAliases as Record<
  string,
  SupportedLocale
>;

export const isSupportedLocale = (
  language: string | null | undefined
): boolean => {
  return supportedLocaleSet.has((language ?? '').toLowerCase());
};

export const resolveSupportedLanguage = (
  language: string | null | undefined
): SupportedLocale => {
  const normalized = (language ?? '').toLowerCase();

  if (isSupportedLocale(normalized)) {
    return normalized;
  }

  const aliasedLocale = localeAliases[normalized];
  if (aliasedLocale) {
    return aliasedLocale;
  }

  const primarySubtag = normalized.split(/[-_]/)[0];
  if (isSupportedLocale(primarySubtag)) {
    return primarySubtag;
  }

  return fallbackLocale;
};
